import moment from "moment";

const converttoWgPhoneFormat = (phone) => {
  //check if already have tag

  if (phone.search("TH") !== -1) {
    return phone;
  } else {
    return `${phone.slice(0, phone.length)}|TH|+66`;
  }
};

const converttoPhoneFormat = (wgPhone, withDash = false) => {
  if (withDash) {
    const num = wgPhone.replace("+66", "").replace(/\D/g, "");
    if (num.length < 10) return num;
    return `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 11)}`;
  } else return wgPhone.replace("+66", "").replace(/\D/g, "");
};

const isPassCondition = ({ logic, var_name, variable }) => {};

const getDiscountfromCoupon = ({ type, logic, var_name, value }) => {
  if (type === "Discount") {
    if (logic === "[paid_amount] - [value]") {
      return { value: value, type: "amount" };
    } else console.error(`This  logic ${logic} is not support`);
  }
};

const getLocalDate = (dateString) => {
  return moment(dateString).format("D MMM YY");
  // return new Date(dateString).toLocaleDateString("th-TH", {
  //   year: "numeric",
  //   month: "numeric",
  //   day: "numeric",
  // });
};

const getLocalTime = (dateString) => {
  return moment(dateString).format("HH:mm");
  // return new Date(dateString).toLocaleTimeString("th-TH", {
  //   hour: "2-digit",
  //   minute: "2-digit",
  //   hour12: false,
  //   timeZone: "Asia/Bangkok",
  // });
};

const removeEmptyFieldfromObject = (data) => {
  Object.entries(data).forEach(([k, v]) => {
    if (k === "rawFile") return; //For Image file
    if (k === "action_codes") return;
    if (v && Array.isArray(v)) return;
    if (v && typeof v === "object") removeEmptyFieldfromObject(v);
    if (
      (v && typeof v === "object" && !Object.keys(v).length) ||
      v === null ||
      v === undefined //||
      //      v.length === 0  except array
    ) {
      if (Array.isArray(data)) data.splice(k, 1);
      else if (!(v instanceof Date)) delete data[k];
    }
  });
  return data;

  //  return Object.fromEntries(
  //  Object.entries(data).filter(([_, v]) => v != null && v !== "")
  //);
};

const removeEmptyStringFieldfromObject = (data) => {
  Object.entries(data).forEach(([k, v]) => {
    if (v && typeof v === "object") removeEmptyStringFieldfromObject(v);
    if (v === "") {
      if (!(v instanceof Date)) delete data[k];
    }
  });
  return data;
};

const calculateAge = (dob) => {
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);

  return Math.abs(age_dt.getUTCFullYear() - 1970);
};

const guessGender = (gender) => {
  return ["M", "Male", "m", "male", "man", "Man"].find((ele) => ele === gender)
    ? "Male"
    : ["F", "Female", "f", "female", "woman", "Woman"].find(
        (ele) => ele === gender
      )
    ? "Female"
    : "Other";
};

const converttoWgGender = (gender) => {
  return ["Male", "ชาย"].find((ele) => ele === gender)
    ? "Male"
    : ["Female", "หญิง"].find((ele) => ele === gender)
    ? "Female"
    : "Other";
};

const isPaymentCardType = (check) => {
  return check === "Credit / Debit Card" || check === "Credit-Debit";
};

const round = (number) => {
  return Math.round(parseFloat(number));
};

const savePaymentState = (data) => {
  try {
    localStorage.setItem(
      "Payment",
      JSON.stringify({
        ...data,
      })
    );

    return [true, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

const loadPaymentState = () => {
  try {
    const localData = JSON.parse(localStorage.getItem("Payment"));

    return [localData, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

const removePaymentState = () => {
  try {
    localStorage.removeItem("Payment");

    return true;
  } catch (error) {
    throw new Error({
      status: 401,
      code: "NoLocalStore",
      message: "Need to login first",
    });
  }
};

const savePaymentMemberState = (data) => {
  try {
    //save member data or guest?
    localStorage.setItem(
      "memberPayment",
      JSON.stringify({
        ...data,
      })
    );

    return [true, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

//Member state kept after select member from payment page
const loadPaymentMemberState = () => {
  try {
    const localData = JSON.parse(localStorage.getItem("memberPayment"));

    return [localData, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

const removePaymentMemberState = () => {
  try {
    localStorage.removeItem("memberPayment");

    return true;
  } catch (error) {
    throw new Error({
      status: 401,
      code: "NoLocalStore",
      message: "Need to login first",
    });
  }
};

const savePaymentGuestState = (data) => {
  try {
    //save member data or guest?
    localStorage.setItem(
      "guestPayment",
      JSON.stringify({
        ...data,
      })
    );

    return [true, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

//Member state kept after select member from payment page
const loadPaymentGuestState = () => {
  try {
    const localData = JSON.parse(localStorage.getItem("guestPayment"));

    return [localData, null];
  } catch (error) {
    return [
      null,
      {
        status: 401,
        code: "NoLocalStore",
        message: "Need to login first",
      },
    ];
  }
};

const removePaymentGuestState = () => {
  try {
    localStorage.removeItem("guestPayment");

    return true;
  } catch (error) {
    throw new Error({
      status: 401,
      code: "NoLocalStore",
      message: "Need to login first",
    });
  }
};

const getMemberType = (state) => {
  if (state.member) return "member";
  return "guest";
};

const getDateTimeFormat = (dateData, periodType) => {
  if (periodType === "All") {
    return "All";
  } else if (periodType === "datetime") {
    return moment(dateData).format("D MMM YYYY HH:mm");
  } else if (periodType === "Month") {
    return moment(dateData).format("MMM YYYY");
  } else if (periodType === "Year") {
    return moment(dateData).format("[Year ]YYYY");
  } else {
    return moment(dateData).format("D MMM YYYY");
  }
};

const getMostOccurenceInArray = (arr) => {
  if (!arr) return ["None"];
  let counts = arr?.reduce((a, c) => {
    a[c] = (a[c] || 0) + 1;
    return a;
  }, {});
  let maxCount = Math.max(...Object.values(counts));
  return Object.keys(counts).filter((k) => counts[k] === maxCount);
};

function abbreviateNumber(value) {
  var newValue = value;
  if (value >= 1000) {
    let suffixes = ["", "K", "M", "B", "T"];
    let suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = "";
    for (let precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum !== 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      let dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}

export {
  converttoWgPhoneFormat,
  getDiscountfromCoupon,
  getLocalDate,
  getLocalTime,
  removeEmptyFieldfromObject,
  isPassCondition,
  calculateAge,
  guessGender,
  converttoPhoneFormat,
  converttoWgGender,
  isPaymentCardType,
  removeEmptyStringFieldfromObject,
  round,
  savePaymentState,
  loadPaymentState,
  removePaymentState,
  getMemberType,
  getDateTimeFormat,
  getMostOccurenceInArray,
  savePaymentMemberState,
  loadPaymentMemberState,
  removePaymentMemberState,
  savePaymentGuestState,
  loadPaymentGuestState,
  removePaymentGuestState,
  abbreviateNumber,
};
